import { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";

const Nav = ({ setLoggedInUser }) => {
	const [showMenu, setShowMenu] = useState(false); //mobile only
	const navigate = useNavigate();
	const ref = useRef(null);
	const loggedInUser = localStorage.getItem("loggedInUser");

	useEffect(() => {
		// anytime path changes, close nav & subnav
		setShowMenu(false);
	}, []);

	const handleLinkClick = (path) => {
		navigate(path);
		setShowMenu(false);
	};

	const handleLogout = () => {
		localStorage.removeItem("loggedInUser");
		if (setLoggedInUser) setLoggedInUser(null);
		navigate("/login");
	};

	return (
		<nav className={showMenu ? "menu-active" : ""}>
			<div className="mobile-toggle " onClick={() => setShowMenu(!showMenu)}>
				<div className="line"></div>
				<div className="line"></div>
				<div className="line"></div>
			</div>
			<ul>
				<li>
					<div onClick={() => handleLinkClick("/dashboard")}>Money Dashboard</div>
				</li>
				<li>
					<div onClick={() => handleLinkClick("/spending-averages")}>Spending Averages</div>
				</li>
				<li>
					<div onClick={() => handleLinkClick("/accounts")}>Accounts</div>
				</li>
				<li>
					<div onClick={() => handleLinkClick("/ledger")}>Ledger</div>
				</li>
				<li>
					<div onClick={() => handleLinkClick("/style-guide")}>Style Guide</div>
				</li>

				<li className="title">Account Balance Routes</li>
				<li>
					<div onClick={() => handleLinkClick("/accountBalance")}>All Account Balances</div>
				</li>
				<li>
					<div onClick={() => handleLinkClick("/addAccountBalance")}>Account Balance Add</div>
				</li>
				{loggedInUser && (
					<li>
						<div className="l-btn secondary" onClick={handleLogout} style={{ cursor: "pointer", marginTop: "10px" }}>
							Logout
						</div>
					</li>
				)}
			</ul>
		</nav>
	);
};

export default Nav;
